import { render, staticRenderFns } from "./rdadvertiser-add-or-update.vue?vue&type=template&id=2c75c83c&"
import script from "./rdadvertiser-add-or-update.vue?vue&type=script&lang=js&"
export * from "./rdadvertiser-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports